import { render, staticRenderFns } from "./DatasourceDsTabBusinessTerm.vue?vue&type=template&id=316210f1&scoped=true&lang=pug"
import script from "./DatasourceDsTabBusinessTerm.vue?vue&type=script&lang=js"
export * from "./DatasourceDsTabBusinessTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316210f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316210f1')) {
      api.createRecord('316210f1', component.options)
    } else {
      api.reload('316210f1', component.options)
    }
    module.hot.accept("./DatasourceDsTabBusinessTerm.vue?vue&type=template&id=316210f1&scoped=true&lang=pug", function () {
      api.rerender('316210f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/DatasourceDsTabBusinessTerm.vue"
export default component.exports